"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.metricHandlers = exports.convertTags = exports.createMetric = void 0;
const types_1 = require("../../../types");
function createMetric(meter, { name, description, unit, type }) {
    switch (type) {
        case types_1.CustomMetricType.COUNT:
            return meter.createCounter(name, { description, unit });
        case types_1.CustomMetricType.RATE:
            return meter.createUpDownCounter(name, { description, unit });
        case types_1.CustomMetricType.GAUGE:
            return meter.createGauge(name, { description, unit });
        case types_1.CustomMetricType.DISTRIBUTION:
            return meter.createHistogram(name, { description, unit });
        default:
            throw new Error(`Unsupported metric type: ${type}`);
    }
}
exports.createMetric = createMetric;
const convertTags = (tags) => {
    return tags.reduce((acc, tag) => {
        const [key, value] = tag.split(':').map((part) => part.trim());
        acc[key] = value;
        return acc;
    }, {});
};
exports.convertTags = convertTags;
exports.metricHandlers = {
    [types_1.CustomMetricType.COUNT]: (metric, value, tags) => metric.add(value, tags),
    [types_1.CustomMetricType.RATE]: (metric, value, tags) => metric.add(value, tags),
    [types_1.CustomMetricType.GAUGE]: (metric, value, tags) => metric.record(value, tags),
    [types_1.CustomMetricType.DISTRIBUTION]: (metric, value, tags) => metric.record(value, tags),
};
//# sourceMappingURL=metrics-definitions.js.map